import { axiosRequest } from '@/plugins/axios-common'

export const ReportsActions = {

  getFiltersOptions (_) {
    return axiosRequest.
      get('/reports/get_filters_options')
  },

  loadAppointmentsReport: async (_, filters) => {
    return axiosRequest.
      get('/reports/appointments', {
        params: {
          assignee_ids: filters.assigneeIds,
          start_date: filters.startDate,
          end_date: filters.endDate,
        },
      })
  },

  loadCasesReport: async (_, filters) => {
    return axiosRequest.
      get('/reports/cases', {
        params: {
          start_date: filters.startDate,
          end_date: filters.endDate,
        },
      })
  },

  loadPartiesReport: async (_, filters) => {
    return axiosRequest.
      get('/reports/parties', {
        params: {
          start_date: filters.startDate,
          end_date: filters.endDate,
          legal_case_types: filters.legalCaseTypes,
        },
      })
  },

  loadPriorityDatesReport: async (_, filters) => {
    return axiosRequest.
      get('/reports/priority_dates', {
        params: {
          start_date: filters.startDate,
          end_date: filters.endDate,
          preference_category: filters.preferenceCategory,
          chargeability: filters.chargeability,
        },
      })
  },

  loadUnassociatedPartiesReport: async _ => {
    return axiosRequest.
      get('/reports/unassociated_parties')
  },

  loadUntrackedCasesReport: async _ => {
    return axiosRequest.
      get('/reports/untracked_cases')
  },

  loadUsersReport: async (_, filters) => {
    return axiosRequest.
      get('/reports/users', {
        params: {
          start_date: filters.startDate,
          end_date: filters.endDate,
        },
      })
  },
}
